import MailReceiveDomain from "@/domains/communityTalk/mailReceiveDomain";
import ApiValidationErrorUtil from "@/modules/utils/apiValidationErrorUtil";
import { ApiErrorViewModel, ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";

/**
 * メール通知周りのController。
 */
export default class MailReceiveController {
	private readonly _mailReceiveDomain: MailReceiveDomain;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._mailReceiveDomain = new MailReceiveDomain();
	}

	/**
	 * メール通知リクエスト送付APIへのリクエスト。
	 * @param talkRoomId 対象のトークルームID。
	 * @param mailAddress 通知先メールアドレス。
	 * @param tenantId 対象のテナントID。
	 * @param publishCookieId ReviCoCookieId。
	 * @param siteUserId サイトのユーザーID。
	 */
	public async postNoticeTalkRoom(talkRoomId: string, mailAddress: string, tenantId?: string, publishCookieId?: string, siteUserId?: string): Promise<string> {
		// Null許容不可能な値がNullである場合、Error
		if (!tenantId) {
			throw new Error("tenantId: value not exist.");
		}
		if (!talkRoomId) {
			throw new Error("talkRoomId: value not exist.");
		}
		if (!mailAddress) {
			throw new Error("mailAddress: value not exist.");
		}
		if (!publishCookieId) {
			throw new Error("publishCookieId: value not exist.");
		}

		try {
			return await this._mailReceiveDomain.postNoticeTalkRoom(tenantId, talkRoomId, mailAddress, publishCookieId, siteUserId);
		} catch (e) {
			// ユーザー起因のバリデーションエラーであればバリデーションエラーメッセージとして返却
			if (ApiValidationErrorUtil.isValidateObject_talkRoomNoticeMail(e)) {
				const errorResult: ApiErrorViewModel = {
					isValidationError: true,
					validationErrorContents: e as ApiValidationErrorViewModel,
					errorContents: e,
				};
				throw errorResult;
			} else {
				// そうでなければエラーオブジェクトをそのまま返却
				const errorResult: ApiErrorViewModel = {
					isValidationError: false,
					validationErrorContents: null,
					errorContents: e,
				};
				throw errorResult;
			}
		}
	}
}
